<template>
    <div class="c-discover-services">
        <div class="c-discover-services__title">
            <h2>
                {{ content.title }}
            </h2>
        </div>
        <div class="c-discover-services__content">
            <y-row>
                <y-col
                    v-for="(item, index) in content.albums"
                    :key="`discover-item-${ index }`"
                    sm="12"
                    md="6"
                    lg="3"
                >
                    <div class="flip-card">
                        <div class="flip-card-inner">
                            <div class="flip-card-front">
                                <div class="title-img-box">
                                    <div class="title-box">
                                        <div class="index-box">
                                            <span>
                                                {{ digits(((index + 1) < 10 ? 0 : '').toString() + (index + 1).toString(), $i18n.locale) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="image-box">
                                        <img
                                            :src="item.link"
                                            :alt="item.title"
                                        >
                                    </div>
                                </div>

                                <div class="title-box">
                                    <h3>
                                        {{ item.title }}
                                        <y-icon
                                            icon="chevron-down"
                                            color="font"
                                            size="small"
                                        />
                                    </h3>
                                </div>
                            </div>
                            <div class="flip-card-back">
                                <div>
                                    <p>
                                        {{ item.description }}
                                    </p>
                                </div>
                                <div v-if="item.hyperlink">
                                    <y-button
                                        flat
                                        :tag="isLink(item.hyperlink) ? 'a' : 'router-link'"
                                        bordered
                                        class="flip-link"
                                        :to="item.hyperlink"
                                        :href="item.hyperlink"
                                        :icon-append="`fa-arrow-${$i18n.locale === 'ar' ? 'left' : 'right'}`"
                                    >
                                        {{ $t('home.discover.link') }}
                                    </y-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </y-col>
            </y-row>
        </div>

        <div class="d-f justify-content-center">
            <y-button
                class="text-box-btn"
                color="primary"
                tag="router-link"
                :to="{name: 'schedule-demo'}"
            >
                {{ $t('general.schedule_demo') }}
            </y-button>
        </div>
        <y-schedule-demo-modal ref="scheduleDemoModal" />
    </div>
</template>

<script>

    import { digits } from '@groot-nodes/helpers/number';
    import { isLink } from '@/helpers/helpers';
    import YScheduleDemoModal from '@components/ScheduleDemo/Index.vue';
    import YIcon from '@groot-components/icon';

    export default {
        name      : 'DiscoverServices',
        components: { YScheduleDemoModal, YIcon },
        props     : { content: Object },
        methods   : {
            digits,
            isLink,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
